import { map } from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';

import Select, { TYPES } from 'components/Select';
import Theme from 'styles/theme';
import I18n from 'utils/I18n';

import { LANGUAGES } from './constants';

const LanguageSelector = ({ supportedLocales, currentLocale, onSelectLanguage }) => (
  <div className="LanguageSelector">
    <h3 className="LanguageSelector__header Footer__heading Typography--quaternary-heading Typography--with-margin">
      {I18n.localize('footer.selectLanguage')}:
    </h3>
    <Select
      id="LanguageSelector__select"
      value={currentLocale}
      type={TYPES.INVERSE}
      onChange={onSelectLanguage}
      ariaLabel={I18n.localize('footer.selectLanguage')}
    >
      {map(supportedLocales, locale => (
        <option key={locale} value={locale}>
          {LANGUAGES[locale]}
        </option>
      ))}
    </Select>
    <style jsx>{`
      .LanguageSelector__header {
        margin-top: ${Theme.get('spacing') * 6}px;
      }
    `}</style>
  </div>
);

LanguageSelector.propTypes = {
  supportedLocales: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentLocale: PropTypes.string.isRequired,
  onSelectLanguage: PropTypes.func.isRequired,
};

export default LanguageSelector;
